<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Asegurador</h4>
    <hr />

    <DataTable
      :data="aseguradors"
      :columns="columnas"
      idField="idAsegurador"
      mensajeVacio="No hay aseguradores registrados."
      :mostrarBotonNuevo="true"
      :mostrarEditar="true"
      :mostrarVer="true"
      :mostrarEliminar="true"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idAsegurador)"
      @view="row => abrirEditar(row.idAsegurador)"
      @delete="row => deleteAsegurador(row.idAsegurador)"
    >
      <!-- Búsqueda por nombre -->
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar nombre..."
            style="width:220px; text-transform:uppercase"
            @keyup.enter="getDataNombre"
          />
          <button
            class="btn btn-outline-primary btn-sm"
            @click="getDataNombre"
            title="Buscar"
          >
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>

      <!-- Celda tipo con badge -->
      <template #cell-tipo="{ row }">
        <span class="badge" :class="badgeTipo(row.tipo)">
          {{ row.tipo }}
        </span>
      </template>
    </DataTable>

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- ID solo en edición -->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">ID</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoAsegurador.idAsegurador"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Nombre Corto -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Nombre Corto</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoAsegurador.nombreCorto"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Nombre -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Nombre</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoAsegurador.nombre"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Tipo -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Tipo</label>
                  </div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoAsegurador.tipo" required>
                      <option value="">Seleccione una opción</option>
                      <option value="PUBLICA">PÚBLICA</option>
                      <option value="PRIVADA">PRIVADA</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarAsegurador"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarAsegurador"
              v-if="btnEditar"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  name: "AseguradorList",
  components: { Layout, Footer, DataTable },

  data() {
    return {
      aseguradors:    [],
      datoAsegurador: {},
      nombreBusqueda: "",
      titulo:         "",
      btnCrear:       false,
      btnEditar:      false,
      modalWindow:    true,
    };
  },

  computed: {
    columnas() {
      return [
        { label: "Nombre Corto", field: "nombreCorto" },
        { label: "Nombre",       field: "nombre"      },
        // tipo usa slot #cell-tipo para badge de color
        { label: "Tipo",         field: "tipo"        },
      ];
    },
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.getData();
  },

  methods: {
    // ── Utilidades ────────────────────────────────────────────
    badgeTipo(tipo) {
      return {
        "bg-primary":           tipo === "PUBLICA",
        "bg-warning text-dark": tipo === "PRIVADA",
        "bg-secondary":         !["PUBLICA", "PRIVADA"].includes(tipo),
      };
    },

    // ── Carga de datos ────────────────────────────────────────
    getData() {
      this.nombreBusqueda = "";
      api.get("/vwaseguradors")
        .then(r => { this.aseguradors = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar aseguradores:", e));
    },

    getDataNombre() {
      const nombre = this.nombreBusqueda.trim();
      if (!nombre) { this.getData(); return; }
      api.get("/vwaseguradors/nombre/" + nombre)
        .then(r => { this.aseguradors = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al buscar asegurador:", e));
    },

    // ── Validación ────────────────────────────────────────────
    validarForm() {
      return validarForm(
        this.datoAsegurador,
        ["nombre", "tipo"],
        ["Nombre", "Tipo"]
      );
    },

    // ── CRUD ──────────────────────────────────────────────────
    async guardarAsegurador() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/aseguradors", this.datoAsegurador);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Asegurador creado exitosamente." });
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async actualizarAsegurador() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/aseguradors", this.datoAsegurador);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Asegurador actualizado exitosamente." });
        this.getData();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    async deleteAsegurador(idAsegurador) {
      const confirm = await Swal.fire({
        title:             "¿Eliminar asegurador?",
        text:              "Esta acción no se puede deshacer.",
        icon:              "warning",
        showCancelButton:  true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText:  "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/aseguradors/" + idAsegurador);
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Modales ───────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow    = true;
      this.datoAsegurador = {};
      this.titulo         = "Crear Asegurador";
      this.btnCrear       = true;
      this.btnEditar      = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(idAsegurador) {
      this.modalWindow = true;
      this.titulo      = "Editar Asegurador";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp          = await api.get("/vwaseguradors/" + idAsegurador);
        this.datoAsegurador = resp.data;
      } catch (e) {
        console.error("Error al cargar asegurador:", e);
        return;
      }
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    abrirEditar(idAsegurador) {
      if (idAsegurador != null) this.$router.push("/aseguradorform/" + idAsegurador);
    },
  },
};
</script>